var render, staticRenderFns
import script from "./WxBtnStandard.vue?vue&type=script&lang=js"
export * from "./WxBtnStandard.vue?vue&type=script&lang=js"
import style0 from "./WxBtnStandard.vue?vue&type=style&index=0&id=083e4e6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083e4e6c",
  null
  
)

export default component.exports